import { useFlickity } from '@/components/hooks/useFlickity'
import { BaseResults } from 'libs/searchspring/components/recommendations/BaseResults'
import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'
import { useState } from 'preact/hooks'
import clsx from 'clsx'

export function CarouselResults({
  className,
  wrapperClassName = '',
  options = { pageDots: false, cellAlign: 'left' },
  productCardSettings
}) {
  const renderWithFlickity = (items) => {
    const { results } = useSearchspringContext()
    const [node, setNode] = useState()
    const { SliderPortal } = useFlickity(node, options, [results])

    return (
      <div
        ref={setNode}
        className={clsx(
          'flex w-full',
          options.pageDots && 'pb-1.5 lg:pb-1.625'
        )}
      >
        <SliderPortal>
          {items}
        </SliderPortal>
      </div>
    )
  }

  return (
    <BaseResults
      className={className}
      wrapperClassName={wrapperClassName}
      productCardSettings={productCardSettings}
      renderWrapper={renderWithFlickity}
    />
  )
}
